<template>
  <div
    class="thumbnail-options"
    v-bind="$attrs"
    v-on="$listeners">
    <div
      v-if="label"
      class="label">
      {{ label }}
    </div>
    <div
      v-for="(thumbnail, index) in thumbnailChoices"
      :key="thumbnail"
      :class="`thumbnail-option thumbnail-${index} ${thumbnail === selectedValue ? 'selected' : ''}`"
      @click="handleClick(thumbnail)">
      <img
        :src="thumbnail"
        alt="Thumbnail option">
      <div class="selected-overlay">
        <div class="background" />
        <icon icon="check_circle" />
      </div>
    </div>
    <div
      v-if="helper"
      class="helper">
      {{ helper }}
    </div>
  </div>
</template>
<script>
import Icon from '../icon/icon.vue'

export default {
  components: {
    Icon
  },
  inheritAttrs: true,
  props: {
    helper: { default: null, required: false, type: String },
    label: { default: null, required: false, type: String },
    thumbnailChoices: { required: true, type: Array },
    value: { required: true, type: [Date, Number, Object, String] }
  },
  data () {
    return {
      selectedValue: this.value
    }
  },
  watch: {
    value () {
      this.selectedValue = this.value
    }
  },
  methods: {
    handleClick (option) {
      this.selectedValue = option
      this.$emit('selectOption', option)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../universal/vars.scss';

  .thumbnail-option {
    display: inline-block;
    margin: 0 4px 4px 0;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    vertical-align: bottom;

    img {
      display: block;
      height: 36px;
      width: 54px;

      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: inherit;
    }
  }
  .thumbnail-0 {
    margin-left: 0;
  }
  .selected-overlay {
    display: flex;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    -webkit-transition: opacity 0.5s ease-in-out;
    .background {
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      background-color: $mdc-theme-primary;
    }
    i {
      color: white;
      opacity: 0;
      z-index: 3;
    }
  }
  .selected .selected-overlay {
    .background {
      opacity: 0.6;
    }
    i {
      opacity: 1;
    }
  }
  .helper, .label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: $black-inactive;
    margin: 8px 0;
  }
</style>
